import React, { useEffect, useState } from "react";
import '../styles/design-system.css'; // Ensure keyframes are available

const SakuraParticles = ({ count = 30 }) => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        // Generate floating particles
        const tempParticles = Array.from({ length: count }).map((_, i) => {
            const size = 6 + Math.random() * 10; // 6-16px, slightly varied
            const left = Math.random() * 100; // 0-100% width
            const animDuration = 15 + Math.random() * 20; // 15-35s (slower, floaty)
            const animDelay = -Math.random() * 30; // Negative delay for instant populate
            const animType = Math.floor(Math.random() * 3) + 1; // 1, 2, or 3

            return {
                id: i,
                style: {
                    position: 'absolute',
                    top: '-10%',
                    left: `${left}%`,
                    width: `${size}px`,
                    height: `${size}px`,
                    background: "radial-gradient(circle, #ffb7b2 0%, #ff9e99 100%)",
                    borderRadius: "50% 0 50% 50%", // Petal shape
                    boxShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                    animationName: `sakura-float-${animType}`,
                    animationDuration: `${animDuration}s`,
                    animationTimingFunction: 'ease-in-out', // Smoother floating
                    animationIterationCount: 'infinite',
                    animationDelay: `${animDelay}s`,
                    opacity: 0,
                    willChange: 'transform, top, opacity',
                }
            };
        });
        setParticles(tempParticles);
    }, [count]);

    // Lightweight CSS-only renderer
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 0,
            }}
        >
            {particles.map((p) => (
                <div key={p.id} style={p.style} />
            ))}
        </div>
    );
};

export default SakuraParticles;
